export default __webpack_public_path__ + "static/media/8.d9de0c73.png";